// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--GYtww","icon":"a10a3f92e9--icon--Jg9PJ","rate":"a10a3f92e9--rate--SxOKW","rate-from":"a10a3f92e9--rate-from--PLc5_"};